import { Spin } from 'antd';
import { Suspense, lazy, type ComponentProps } from 'react';

// Shares the heavy three + @react-three/* vendor chunk with PartModelViewer. Stock
// previews appear inside material-selection modals, so nothing needs this code
// until one of those is opened — load it then rather than on every page.
//
// Import this module instead of ./index.tsx — the Suspense boundary lives here,
// so call sites need no extra plumbing.
const ThreeDStockSizePreviewer = lazy(() => import('./index.tsx'));

type Props = ComponentProps<typeof ThreeDStockSizePreviewer>;

export default function LazyThreeDStockSizePreviewer(props: Props) {
	return (
		<Suspense
			fallback={
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						minHeight: 120,
					}}
				>
					<Spin />
				</div>
			}
		>
			<ThreeDStockSizePreviewer {...props} />
		</Suspense>
	);
}
